function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 21987",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 21987"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 20004",
    style: {
      fill: "transparent"
    },
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17771",
    d: "M7.942 5.745v2.2m0 2.2h.005m4.936-2.2A4.942 4.942 0 1 1 7.942 3a4.942 4.942 0 0 1 4.942 4.942Z",
    transform: "translate(-.036 -.036)",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  })));
};

export default SvgWarning;